import { getLocalStorageItem, setLocalStorageItem } from '@drc-eca/eca-lrc-common-ui';
import { UUID } from '../utilities/uuid';

const getQueryParam = (name: string): string => {
  const url = window.location.href;

  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[\]]/g, '\\$&');

  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getLocalStorage = (key: string): string => {
  return getLocalStorageItem(key);
};

const getSessionStorage = (key: string): string => {
  const value = sessionStorage.getItem(key);
  return value || '';
};

const getClientAbbr = (): string => {
  // removes the quotes around the string
  const client = getQueryParam('c') || getLocalStorage('client') || getSessionStorage('ngStorage-ecaselectedClient').substr(1).slice(0, -1);
  if (client) {
    setLocalStorageItem('client', client);
  }
  return client;
};

const clientAbbr = getClientAbbr();

export function initialState() {
  return {
    config: {},
    siteInformation: {
      client: clientAbbr,
      path: null,
    },
    token: '',
    user: null,
    session: {
      id: UUID.v4(),
      unsubmitted: [],
      fetchError: null,
    },
    diagnostics: {
      results: {},
    },
    results: {
      current: [],
      successful: [],
      failures: [],
      processing: [],
      hasFailures: false,
      hasSuccessful: false,
      hasProcessing: false,
      errors: [],
    },
    scannerStatus: {
      initialized: false,
      busy: false,
      current: 'missing',
      availableScanners: {},
      activeScanner: undefined,
      apiOffline: false,
    },
    batchStatus: [],
    scans: {
      entities: {},
      synced: [],
      unsynced: [],
      scoringStatus: 'not-sent',
      scans: [],
      completed: false,
      formStatus: 'Published',
      lastTotal: 0,
      totalScans: 0,
      completedScans: 0,
    },
    policy: {
      apiPolicy: null,
    },
    polling: false,
  };
}
